import Dexie, { type Table } from "dexie";
import type {
  FavouriteSitesRecord,
  MachineRecord,
  NotificationRecord,
  OffsetRecord,
  ProgressRecord,
  QuickActionRecord,
  ScreenRecord,
  ScreenLayoutTemplate,
  SettingRecord,
  TemplateRecord,
} from "../types";

export const DEFAULT_DB_NAME = "marlin-store";

export class MarlinStoreDb extends Dexie {
  screens!: Table<ScreenRecord, number>;
  templates!: Table<TemplateRecord, string>;
  screenTemplates!: Table<ScreenLayoutTemplate, string>;
  machines!: Table<MachineRecord, number>;
  quickActions!: Table<QuickActionRecord & { createdAt?: number }, string>;
  notifications!: Table<NotificationRecord, number>;
  progress!: Table<
    ProgressRecord & { createdAt?: number },
    [string, number, string]
  >;
  offsets!: Table<OffsetRecord, [number, string]>;
  settings!: Table<SettingRecord, string>;
  favouriteSites!: Table<FavouriteSitesRecord, string>;

  constructor(name: string) {
    super(name);
    this.version(1).stores({
      screens: "id",
      templates: "id",
      screenTemplates: "id",
      machines: "_id, machine_id, site_id",
      quickActions: "id, createdAt",
      notifications:
        "++rowId, &[machineId+id], timestamp, siteId, [machineId+siteId+type+subtype]",
      progress:
        "[actionId+machineId+messageId], actionId, machineId, [machineId+messageId], createdAt",
      offsets: "[machineId+topic], machineId",
      settings: "key",
      favouriteSites: "cognitoSub",
    });
  }
}

export const openStoreDb = (name: string = DEFAULT_DB_NAME): MarlinStoreDb =>
  new MarlinStoreDb(name);

export const onVersionChange = (db: Dexie, onClosed: () => void): void => {
  db.on("versionchange", () => {
    db.close();
    onClosed();
    return false;
  });
  db.on("blocked", () => {
    onClosed();
  });
};
